import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "expand",
  "use": "expand-usage",
  "viewBox": "0 0 10 6",
  "content": "<symbol viewBox=\"0 0 10 6\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"expand\">\n<path d=\"M8.84828 0.849243H1.15172C0.920869 0.849243 0.791968 1.09298 0.934931 1.25938L4.78321 5.7217C4.89336 5.84943 5.10546 5.84943 5.21679 5.7217L9.06507 1.25938C9.20803 1.09298 9.07913 0.849243 8.84828 0.849243Z\" fill=\"#B1B4BD\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol